export default "__VITE_ASSET__CN02RY7Y__"